import script from "./case_purchase_add_btn.vue?vue&type=script&setup=true&lang=js"
export * from "./case_purchase_add_btn.vue?vue&type=script&setup=true&lang=js"

import "./case_purchase_add_btn.vue?vue&type=style&index=0&id=9db676dc&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9db676dc"]])

export default __exports__